import fetalMonitor from '@/utils/fetalMonitorAlgorithm.js';

const DECEL_NONE = 0;
const DECEL_EARLY = 1;
const DECEL_LATE = 2;
const DECEL_VARIABLE = 3;
const DECEL_PROLONGED = 4;

const DECEL_NONE_TYPE = 0;
const DECEL_EARLY_TYPE = 'ED';
const DECEL_LATE_TYPE = 'LD';
const DECEL_VARIABLE_TYPE = 'VD';
const DECEL_PROLONGED_TYPE = 'PD';

function filterFetalData (form) {
	let data = form.tbData.split(',').map(Number)
	return fetalMonitor.filterFetalData(data)
}

function filterFetalData2 (tbData) {
	let data = tbData.split(',').map(Number)
	return fetalMonitor.filterFetalData(data)
}

function formatSeconds (totalSeconds) {
	// 1. 边界处理：非数字或负数转0
	if (typeof totalSeconds !== 'number' || totalSeconds <= 0) return '0秒';
	totalSeconds = Math.floor(totalSeconds); // 取整秒数[1][6]

	// 2. 计算分钟和剩余秒数
	const minutes = Math.floor(totalSeconds / 60);
	const seconds = totalSeconds % 60;

	// 3. 按条件拼接结果
	if (minutes === 0) { // 小于1分钟
		return `${seconds}秒`; // 直接显示秒
	} else if (seconds === 0) { // 整分钟（无剩余秒）
		return `${minutes}分钟`; // 不显示秒
	} else { // 常规情况（分钟+秒）
		return `${minutes}分钟${seconds.toString().padStart(2, '0')}秒`; // 秒数补零[2][8]
	}
}



function score (form) {
	let data = null;
	let is_not_filter = false; //是否未过滤数据
	let week = 30
	if (form.tbWeek && form.tbWeek.includes('周')) {
		week = Number(form.tbWeek.slice(0, form.tbWeek.indexOf('周')))
	}
	if (form.tbScoreData) {
		data = form.tbScoreData.split(',').map(Number)
	} else {
		data = form.tbData.split(',').map(Number)
		is_not_filter = true
	}
	const seconds = Math.floor(data.length / 4)
	let scoreTime = ''
	if (!form.tbStartTime) {
		form.tbStartTime = form.createTime
	}
	if (form.tbEndTime) {
		scoreTime = new Date(form.tbEndTime.replace(/-/g, '/'))
	} else {
		scoreTime = new Date(new Date(form.tbStartTime.replace(/-/g, '/')).getTime() + 1000 * seconds)
	}

	let result = fetalMonitor.fetalMonitoringScore(data, [], data.length, week, is_not_filter)

	result.duration = formatSeconds(seconds)
	result.scoreTime = scoreTime
	if (result.deceleration_count === 0) {
		result.deceleration_type = DECEL_NONE_TYPE;
	} else {
		let has_late = false, has_variable = false, has_prolonged = false;
		for (let i = 0; i < result.deceleration_count; i++) {
			if (result.decelerations[i].type === DECEL_LATE) has_late = true;
			if (result.decelerations[i].type === DECEL_VARIABLE) has_variable = true;
			if (result.decelerations[i].type === DECEL_PROLONGED) has_prolonged = true;
		}
		if (has_late) {
			result.deceleration_type = DECEL_LATE_TYPE;
		} else if (has_prolonged) {
			result.deceleration_type = DECEL_PROLONGED_TYPE;
		} else if (has_variable) {
			result.deceleration_type = DECEL_VARIABLE_TYPE;
		} else {
			result.deceleration_type = DECEL_EARLY_TYPE;
		}
	}
	return result
}


function score2 (tbData, tbScoreData, tbStartTime, tbEndTime, createTime, tbWeek) {
	let data = null;
	let is_not_filter = false; //是否未过滤数据
	let week = 30
	if (tbWeek && tbWeek.includes('周')) {
		week = Number(tbWeek.slice(0, tbWeek.indexOf('周')))
	}
	if (tbScoreData) {
		data = tbScoreData.split(',').map(Number)
	} else {
		data = tbData.split(',').map(Number)
		is_not_filter = true
	}
	const seconds = Math.floor(data.length / 4)
	let scoreTime = ''
	if (!tbStartTime) {
		tbStartTime = createTime
	}
	if (tbEndTime) {
		scoreTime = new Date(tbEndTime.replace(/-/g, '/'))
	} else {
		scoreTime = new Date(new Date(tbStartTime.replace(/-/g, '/')).getTime() + 1000 * seconds)
	}

	let result = fetalMonitor.fetalMonitoringScore(data, [], data.length, week, is_not_filter)
	result.duration = formatSeconds(seconds)
	result.scoreTime = scoreTime
	if (result.deceleration_count === 0) {
		result.deceleration_type = DECEL_NONE_TYPE;
	} else {
		let has_late = false, has_variable = false, has_prolonged = false;
		for (let i = 0; i < result.deceleration_count; i++) {
			if (result.decelerations[i].type === DECEL_LATE) has_late = true;
			if (result.decelerations[i].type === DECEL_VARIABLE) has_variable = true;
			if (result.decelerations[i].type === DECEL_PROLONGED) has_prolonged = true;
		}
		if (has_late) {
			result.deceleration_type = DECEL_LATE_TYPE;
		} else if (has_prolonged) {
			result.deceleration_type = DECEL_PROLONGED_TYPE;
		} else if (has_variable) {
			result.deceleration_type = DECEL_VARIABLE_TYPE;
		} else {
			result.deceleration_type = DECEL_EARLY_TYPE;
		}
	}
	return result
}

export default {
	score,
	score2,
	filterFetalData,
	filterFetalData2
}


